import { TState } from 'redux/config/root-types'
import { call, select } from 'redux-saga/effects'
import DateConverter from 'utils/helpers/date'
import { RequestMethods } from 'utils/axios/methods'
import { sagaAction_Error } from 'redux/sagas/actions/SagaAction_Error'
import { AxiosRequestConfig } from 'axios'

const { download } = RequestMethods()

export default function* SagaWorker_GetReportXlsx() {
  const getSelectedOrganizationIds = (state: TState) => state.organizations.selectedOrganizationIds
  const getFilter = (state: TState) => state.report.filter

  //------------------------- Getting request params ---------------------------//
  const organization: ReturnType<typeof getSelectedOrganizationIds> = yield select(getSelectedOrganizationIds)
  const filter: ReturnType<typeof getFilter> = yield select(getFilter)

  const formData = {
    organization,
    orderBy: filter.orderBy,
    sorting: filter.sorting,
    fromDate: filter.fromDate ? DateConverter.toISOString(DateConverter.toStartOfDay(filter.fromDate)) : undefined,
    toDate: filter.toDate ? DateConverter.toISOString(DateConverter.toEndOfDay(filter.toDate)) : undefined,
  }

  const config = {
    responseType: 'blob',
  } as AxiosRequestConfig

  try {
    //------------------------- Getting report ---------------------------//
    yield call(async () => download('/trailers/report/xlsx', formData, config, 'report.xlsx'))
  } catch (e) {
    yield call(() => sagaAction_Error(e))
  }
}
